<template>
    <v-col cols="12">
        <v-row no-gutters>
            <AppStoreTabsItems
                :value="selectedTab"
                :all-tabs="tabs"
            >
                <template v-slot:content="{tab}">
                    <component
                        :is="tab.component"
                        :is-selected="selectedTabName === tab.name"
                    />
                </template>
            </AppStoreTabsItems>
        </v-row>
    </v-col>
</template>

<script>
import {ref, computed} from "@vue/composition-api";
import {$t} from "@/i18n";

import EmailingDialogEmailAddressesTab from "@/views/AppStore/Emailing/EmailingDialogEmailAddressesTab.vue";
import EmailingDialogOverviewTab from "@/views/AppStore/Emailing/EmailingDialogOverviewTab";
import EmailingDialogTemplatesTab from "@/views/AppStore/Emailing/EmailingDialogTemplatesTab";
import EmailingDialogSettingsTab from "@/views/AppStore/Emailing/Settings/EmailingDialogSettingsTab";
import AppStoreTabs from "@/components/AppStore/AppStoreDialogTabs";
import AppStoreTabsItems from "@/components/AppStore/AppStoreDialogTabsItems";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import {TAB_NAMES} from "@/views/AppStore/app-tabs";
import EmailingDialogSignaturesTab from "./EmailingDialogSignaturesTab.vue";
import AccountModule from '../../../store/modules/account'

export default {
    name: "EmailingDialogContent",
    components: {
        AppStoreTabs,
        AppStoreTabsItems
    },
    props: {
        defaultTab: {
            type: String,
            default: ''
        }
    },
    setup(props, ctx) {
        const {appStoreDialogGetters, appStoreDialogActions, appStoreDialogFlags} = appStoreDialog()
        const {isFeatureEnabled} = AccountModule();
        const uglyHack = isFeatureEnabled(appStoreDialogGetters.getAccountIdFromAppData(), 'documents', false)  // this is an awful hack and needs to be removed ASAP

        const allTabs = ref([
            {
                name: TAB_NAMES.OVERVIEW,
                text: $t("Overview"),
                component: EmailingDialogOverviewTab,
            },
            {
                name: TAB_NAMES.TEMPLATES,
                text: $t("Templates"),
                component: EmailingDialogTemplatesTab,
                if: appStoreDialogFlags.isFeatureActive
            },
            {
                name: TAB_NAMES.EMAIL_ADDRESSES,
                text: $t("Email addresses"),
                component: EmailingDialogEmailAddressesTab,
                if: appStoreDialogFlags.isFeatureActive
            },
            {
                name: TAB_NAMES.SIGNATURES,
                text: $t("Signatures"),
                component: EmailingDialogSignaturesTab,
                if: appStoreDialogFlags.isFeatureActive
            },
            {
                name: TAB_NAMES.SETTINGS,
                text: $t("Settings"),
                component: EmailingDialogSettingsTab,
                if: () => appStoreDialogFlags.isFeatureActive && uglyHack
            },
        ]);

        appStoreDialogActions.setTabs(allTabs);
        const tabs = computed(() => appStoreDialogGetters.getTabs());
        const selectedTab = computed(() => appStoreDialogGetters.getSelectedTab());
        const selectedTabName = computed(() => appStoreDialogGetters.getSelectedTabName());

        if (props.defaultTab) {
            appStoreDialogActions.updateCurrentTab(props.defaultTab)
        }

        return {
            tabs,
            selectedTab,
            selectedTabName
        };
    }
};
</script>
